module.exports = __webpack_public_path__ + "assets/img/4_119_big.ae9033d6.jpg";